<template lang="pug">
Auth(@loginFailed="onFailedAuthentication")
  Header(v-if="headerContent" :content="headerContent")
  ModalPage(
    ref="modalPage"
    v-if="uid",
    @closeModalPage="closeModalPage",
    :modalPageContentId="modalPageContentId",
    :showModal="showModalPage")
  div(v-if="uid").wrap-tutorial
    div(v-if="currentIndex == 1").tutorial-content
      ModuleTutorialWelcome(:ref="tutorialContents[currentIndex]")
    div(v-if="currentIndex == 2").tutorial-content
      ModuleTutorialSetProfile(:ref="tutorialContents[currentIndex]")
    div(v-if="currentIndex == 3").tutorial-content
      ModuleTutorialCounseling(:ref="tutorialContents[currentIndex]")
    div(v-if="currentIndex == 4").tutorial-content
      ModuleEventSuggestion(:ref="tutorialContents[currentIndex]")
    div.index-footer
      div.footer-content.f.fm.flex-around.py20
        div
          span(@click="onBack"
            :class="{'active': currentIndex != 1 }").fz14.cursor-pointer BACK
          //- v-icon(v-if="currentIndex != 1") keyboard_arrow_left
        div.index-circle.f.fm
          div(
            v-for="i in contentNum"
            :class="{'active': i == currentIndex }"
            @click="onCircle(i)").circle.mr8
        div
          span(@click="onNext").active.fz14.cursor-pointer NEXT
          //- v-icon keyboard_arrow_right
</template>

<style lang="scss" scoped>
.wrap-tutorial {
  position: relative;
  width: 100%;
  min-height: 100vh;
  .tutorial-content {
    height: calc(100vh - 64px);
  }
  .index-footer {
    background: #fff;
    position: fixed;
    width: 100%;
    height: 64px;
    left: 0;
    bottom: 0;
    box-shadow: 0px 2px 10px rgba(0,0,0,0.3);
    .footer-content {
      width: 93%;
      max-width: 820px;
      margin: 0 auto;
      span {
        color: #bbb;
        &.active {
          color: #2a2a2a;
        }
      }
      .index-circle {
        .circle {
          display: block;
          width: 6px;
          height: 6px;
          background: #bbb;
          &.active {
            background: #2a2a2a;
          }
        }
      }
    }
  }
}
</style>

<script>
import db from "@/components/utils/firebase"
import { sendTrackingEvent } from "@/components/utils/eventTracker"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers("auth")
import Auth from "@/components/auth"
import Header from "@/components/shared/Header"
import ModalPage from "@/components/shared/ModalPage.vue"
import ModuleTutorialWelcome from "@/components/module/ModuleTutorialWelcome"
import ModuleTutorialSetProfile from "@/components/module/ModuleTutorialSetProfile"
import ModuleTutorialCounseling from "@/components/module/ModuleTutorialCounseling"
import ModuleEventSuggestion from "@/components/module/ModuleEventSuggestion"

export default {
  components: {
    Auth,
    Header,
    ModalPage,
    ModuleTutorialWelcome,
    ModuleTutorialSetProfile,
    ModuleTutorialCounseling,
    ModuleEventSuggestion
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  data () {
    return  {
      headerContent: null,
      showModalPage: false,
      modalPageContentId: "",
      currentIndex: 1,
      contentNum: 4,
      tutorialContents: ["welcome", "setProfile", "counseling", "eventSuggestion"]
    }
  },
  created () {
    
  },
  watch: {
    '$route': function (to, from) {
      this.routeModalPage()
    }
  },
  methods: {
    async routeModalPage () {
      this.headerContent = {}
      console.log("name:", this.$route.name)
      if (this.$route.name === "tutorial_event_detail") {
        this.showModalPage = true
        this.modalPageContentId = "detail_event"
        this.headerContent = {
          label: "イベント",
          leftAction: {
            icon: "navigate_before",
            method: () => {
              this.$router.push("/tutorial")
            }
          }
        }
      } else {
        this.showModalPage = false
        this.modalPageContentId = ""
        this.headerContent = null
      }
    },
    closeModalPage () {
      this.showModalPage = false
    },
    onFailedAuthentication () {
      this.$router.push("/sign-in")
    },
    onBack () {
      if (this.currentIndex !== 1) this.currentIndex--
    },
    async onNext () {
      if (this.currentIndex !== this.contentNum) {
        var currentComponent = this.$refs[this.tutorialContents[this.currentIndex]]
        if (currentComponent.save) currentComponent.save()
        this.currentIndex++
      } else {
        console.log("complete tutorial")
        await db.collection("TRAINEE").doc(this.uid).update({
          completeTutorial: true
        })
        sendTrackingEvent("Complete Tutorial", {
          uid: this.uid,
          path: this.$route.name
        })
        this.$router.push("/calendar")
      }
    },
    onCircle (i) {
      this.currentIndex = i
    }
  }
}
</script>
